
import React, { useState } from 'react';
import {
  InputGrid,
  useResponsiveParams,
  Text,
  useQuantaFormikContext,
  NotificationList,
} from 'quanta-ui';
import {
  DISCOUNT_DROPDOWN_DETAILS,
  PINCODE_LOOKUP,
} from '../../queries';

import { useQuery } from '@apollo/client';
import {Loading} from 'quanta-flows/modules/layout';
import { useFetchQuery } from 'quanta-flows';
//import Parse from '../../../../../../lib/intl/CurrencyFormater';
// Parse is changed to CurrencyFormater
import {CurrencyFormater} from 'quanta-flows';
import moment from 'moment';

export default function Discounts({
  branding,
  lobCode,
  lobName,
  productCode,
  productName,
  quoteNumber,
  modify,
}) {
  const fetchQuery = useFetchQuery();
  const getDomainData = (
    domainArr,
    searchText,
    searchType,
    returnType,
  ) => {
    return domainArr.find(
      (d) =>
        d[`${searchType}`]?.toString()?.trim()?.toLowerCase() ===
        searchText?.toString()?.trim()?.toLowerCase(),
    )
      ? domainArr.find(
          (d) =>
            d[`${searchType}`]?.toString()?.trim()?.toLowerCase() ===
            searchText?.toString()?.trim()?.toLowerCase(),
        )[`${returnType}`]
      : '';
  };

  const { values, setFieldValue } = useQuantaFormikContext();
  const [alerts, setAlerts] = useState([]);
  const [loadingPermCustAddr, setLoadingPermCustAddr] =
    useState(false);

  const noOfColsMobile = 1,
    noOfColsDesktop = 3;

  let inputColSpans = useResponsiveParams({
    for_mobile: noOfColsMobile,
    for_desktop: noOfColsDesktop,
  });

  const { loading: loadingDiscountData, data: discountData } =
    useQuery(DISCOUNT_DROPDOWN_DETAILS, {
      fetchPolicy: 'cache-first',
      variables: {
        productCode,
      },
      onCompleted: (data) => {
        if (!values?.voluntaryDeductibleAmount) {
          setFieldValue(
            'voluntaryDeductibleAmount',
            data?.PRD_VoluntaryDeductibleAmount[0]?.code,
          );
        }
        if (!values?.vehicleIsOwnedBy) {
          // setFieldValue(
          //   'vehicleIsOwnedBy',
          //   data?.PRD_vehicleOwnedByList[0]?.code,
          // );
          setFieldValue(`vehicleOwnerTypeAndGender`, {
            gender: data?.PRD_vehicleOwnedByList[0]?.code
              ?.split('#')[1]
              ?.trim()
              ? data?.PRD_vehicleOwnedByList[0]?.code
                  ?.split('#')[1]
                  ?.trim()
              : '',
            organisationType: data?.PRD_vehicleOwnedByList[0]?.code
              ?.split('#')[0]
              ?.trim()
              ? data?.PRD_vehicleOwnedByList[0]?.code
                  ?.split('#')[0]
                  ?.trim()
              : '',
          });
          if (
            getDomainData(
              PRD_vehicleOwnedByList,
              data?.PRD_vehicleOwnedByList[0]?.code,
              'code',
              'value',
            )
              ?.toString()
              ?.trim()
              ?.toLowerCase()
              ?.startsWith('organisation')
          ) {
            setFieldValue(`getAdditionalCreditScore`, 'No');
            setFieldValue(`idProofType`, '');
            setFieldValue(`idProofNumber`, '');
          }
        }
      },
    });

  if (loadingDiscountData) {
    return (
      <div className="min-h-full">
        <Loading customMessage={'Fetching discount details'} />
      </div>
    );
  }
  const {
    PRD_vehicleOwnedByList,
    PRD_IDProofTypeForCreditScoreList,
    PRD_VoluntaryDeductibleAmount,
  } = discountData;

  const onPermAddrLookup = async (val, setFieldValue) => {
    if ((values?.quotationNo !== '' && !modify)) {
      return;
    }
    if (
      !(
        val.toString().length !== 6 ||
        !val.toString().match(/^[0-9]+$/)
      )
    ) {
      let queryOutput = fetchQuery({
        query: PINCODE_LOOKUP,
        variables: {
          filter: {
            pincode: val,
          },
        },
      });
      try {
        setAlerts([]);
        setLoadingPermCustAddr(true);
        let { data } = await queryOutput;
        setLoadingPermCustAddr(false);
        setFieldValue('state', data?.pincodeInfo?.state);
        setFieldValue('district', data?.pincodeInfo?.district);
        setFieldValue('city', data?.pincodeInfo?.city);
      } catch (error) {
        setAlerts([
          {
            header: 'Address fetch failed',
            id: Date.now(),
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                <span>{error.message}</span>
              </div>
            ),
            type: 'error',
            timeout: null,
            disableClose: false,
          },
        ]);
        setLoadingPermCustAddr(false);
        setFieldValue('state', '');
        setFieldValue('district', '');
        setFieldValue('city', '');
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  };

  let grid_data = [
    getDomainData(
      PRD_vehicleOwnedByList,
      values?.vehicleIsOwnedBy,
      'code',
      'value',
    )
      ?.toString()
      ?.trim()
      ?.toLowerCase()
      ?.startsWith('individual')
      ? {
          type: 'radiogroup',
          label: (
            <>
              Do you want to get additional discounts based on credit
              score?<Text severity="error"></Text>
            </>
          ),
          colSpan: inputColSpans,
          name: 'getAdditionalCreditScore',
          disabledGlobal: (values?.quotationNo !== '' && !modify),
          data: [
            {
              label: 'Yes',
              value: 'Yes',
            },
            {
              label: 'No',
              value: 'No',
            },
          ],
        }
      : null,
    values?.getAdditionalCreditScore === 'Yes'
      ? {
          type: 'select',
          size: 'large',
          label: (
            <>
              ID Proof Type<Text severity="error"> *</Text>
            </>
          ),
          name: 'idProofType',
          disabled:(values?.quotationNo !== '' && !modify),
          data: PRD_IDProofTypeForCreditScoreList
            ? [
                ...PRD_IDProofTypeForCreditScoreList.map(
                  (idProofType) => {
                    return {
                      label: idProofType.value
                        ? idProofType.value
                        : '',
                      value: idProofType.code ? idProofType.code : '',
                    };
                  },
                ),
              ]
            : [],
        }
      : null,
    values?.getAdditionalCreditScore === 'Yes'
      ? {
          type: 'text',
          size: 'large',
          className: 'uppercase',
          disabled: (values?.quotationNo !== '' && !modify),
          label: (
            <>
              ID Proof Number<Text severity="error"> *</Text>
            </>
          ),
          name: 'idProofNumber',
          onDataChange: (val, setFieldValue) => {
            setFieldValue(
              `idProofNumber`,
              val?.toString()?.toUpperCase(),
            );
          },
        }
      : null,
    values?.getAdditionalCreditScore === 'Yes'
      ? {
        type: 'text',
        size: 'large',
        disabled: (values?.quotationNo !== '' && !modify),
        label: (
          <>
            First Name<Text severity="error"> *</Text>
          </>
        ),
        name: 'cs_proposer_first_name',
      }
      : null,
    values?.getAdditionalCreditScore === 'Yes'
      ? {
        type: 'text',
        size: 'large',
        disabled: (values?.quotationNo !== '' && !modify),
        label: (
          <>
            Last Name<Text severity="error"> *</Text>
          </>
        ),
        name: 'cs_proposer_last_name',
      }
      : null, ,
    values?.getAdditionalCreditScore === 'Yes'
      ? {
        type: 'number',
        onKeyDown: (evt) => evt.key === 'e' && evt.preventDefault(),
        label: (
          <div>
            Mobile Number <Text severity="error">*</Text>
          </div>
        ),
        name: 'cs_proposer_mobileNo',
        disabled: (values?.quotationNo !== '' && !modify),
        }
      : null, ,
    values?.getAdditionalCreditScore === 'Yes'
      ? {
        type: 'date',
        maxdate: moment()
          .subtract(18, 'years')
          .subtract(1, 'days')
          .format('DD/MM/YYYY'),
        label: (
          <div>
            Date Of Birth <Text severity="error">*</Text>
          </div>
        ),
        name: 'cs_proposerDOB',
        disabled:(values?.quotationNo !== '' && !modify),
      }
      : null,
    // values?.getAdditionalCreditScore === 'Yes'
    //   ? {
    //     type: 'render',
    //     component: () => <></>,
    //   }
    //   : null,
      productCode?.toString() !== '3176' ?
    {
      type: 'select',
      size: 'large',
      label: (
        <>
          Voluntary Deductible Amount<Text></Text>
        </>
      ),
      name: 'voluntaryDeductibleAmount',
      disabled: (values?.quotationNo !== '' && !modify),
      className: `${
        (values?.quotationNo !== '' && !modify)? 'border-neutral-dark' : ''
      }`,
      iconPre: (
        <Text
          severity={
            (values?.quotationNo !== '' && !modify) ? 'neutral-darker' : 'info'
          }
        >
          {branding.currency}
        </Text>
      ),
      data: PRD_VoluntaryDeductibleAmount
        ? [
            ...PRD_VoluntaryDeductibleAmount.map(
              (voluntaryDeductibleAmount) => {
                return {
                  label: voluntaryDeductibleAmount.value ? parseInt(voluntaryDeductibleAmount.value) 
                    // ? Parse
                    // (
                    //     parseInt(voluntaryDeductibleAmount.value),
                    //     false,
                    //     false,
                    //     branding,
                    //     false,
                    //   )
                    : '',
                  value: voluntaryDeductibleAmount.code?.toString()
                    ? parseInt(voluntaryDeductibleAmount.code?.toString())
                    : '',
                };
              },
            ),
          ]
        : [],
    }
    :null,
  ].filter((d) => d);

  return (
    <>
      <InputGrid
        data={grid_data}
        repeat={inputColSpans}
        titleType="title"
        titleSeverity="info"
        size="large"
        gapX={10}
      />
      <div>
        <NotificationList {...{ items: alerts }} />
      </div>
    </>
  );
}
